'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialAndroid = function IoSocialAndroid(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11 20.9v-5.9h17.5v13c0 0.5-0.3 1.1-0.9 1.1h-2.1v4c0 1-0.9 1.9-1.9 1.9h-0.1c-0.5 0-0.8-0.2-1.1-0.4-0.4-0.3-0.7-0.8-0.7-1.5v-4h-3.8v4c0 1-0.9 1.9-1.9 1.9s-1.9-0.9-1.9-1.9v-4h-2.2c-0.6 0-0.9-0.6-0.9-1.1v-7.1z m20.6-7.1c1 0 1.9 0.8 1.9 1.8v7.5c0 1-0.9 1.9-1.9 1.9s-1.8-0.9-1.8-1.9v-7.5c0-1 0.8-1.8 1.8-1.8z m-23.7 0c1 0 1.9 0.8 1.9 1.8v7.5c0 1-0.9 1.9-1.9 1.9s-1.9-0.9-1.9-1.9v-7.5c0-1 0.9-1.8 1.9-1.8z m16.1-6.8c3.8 1.6 4.4 5.6 4.5 6.8h-17.5c0.1-1.2 0.6-5.2 4.4-6.8l-1.4-1.8c0 0 0 0 0-0.1s0.3-0.1 0.3-0.1l1.5 1.8c1.1-0.4 2.4-0.7 3.9-0.7s2.9 0.3 4 0.7l1.5-1.8c0-0.1 0.1 0 0.2 0.1l0.1 0.1z m-8.1 3.9c0.6 0 1-0.5 1-1.1s-0.4-1.1-1-1.1c-0.6 0-1.1 0.6-1.1 1.1s0.6 1.1 1.1 1.1z m7.7 0c0.5 0 1.1-0.5 1.1-1.1s-0.6-1.1-1.1-1.1c-0.6 0-1 0.6-1 1.1s0.4 1.1 1 1.1z' })
        )
    );
};

exports.default = IoSocialAndroid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-android.js
// module id = 2649
// module chunks = 0